import {baseKeysUseQuery} from '#/hooks/query/base/base-keys-use-query';
import {fetchLands} from '#/repository/fetch-lands';
import {useQuery} from '@tanstack/react-query';

export const useLands = (enabled = true) =>
  useQuery({queryKey: [baseKeysUseQuery.useLands], queryFn: fetchLands, enabled});
